import Vue from 'vue'
import App from './App.vue'
import router from './router'
//import qs from 'qs';
import wx from 'weixin-js-sdk';
//import KProgress from 'k-progress';
//import 'fullpage.js/vendors/scrolloverflow';
//import VueFullPage from 'vue-fullpage.js';
//import ElementUI from 'element-ui'
//import i18n from './i18n/i18n'
//import vueToTop from 'vue-totop'
// import ViewUI from 'view-design';
// import 'view-design/dist/styles/iview.css';

// Vue.use(ViewUI);

//import 'element-ui/lib/theme-chalk/index.css'

import './assets/fonts/fonts.css'

//import store from './store';


import "lib-flexible/flexible"       // 自适配
//import FastClick from 'fastclick'    // 移动端300ms延迟

import '@vant/touch-emulator';
import { Toast } from 'vant';
import { Image as VanImage } from 'vant';
//import { Circle } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Dialog } from 'vant';
import { CountDown } from 'vant';
import { Button } from 'vant';
import { Lazyload } from 'vant';
import { Loading } from 'vant';
import { Overlay } from 'vant';
import { Popup } from 'vant';
import { Icon } from 'vant';
import { Form } from 'vant';
import { Field } from 'vant';
import { Picker } from 'vant';
import { Area } from 'vant';
import { Uploader } from 'vant';
import { Empty } from 'vant';
import { List } from 'vant';
import { Progress } from 'vant';
import { Popover } from 'vant';
import { Tab, Tabs } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { Divider } from 'vant';


Vue.use(Toast);
Vue.use(VanImage);
//Vue.use(Circle);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Dialog);
Vue.use(CountDown);
Vue.use(Button);
Vue.use(VanImage);
Vue.use(Lazyload);
Vue.use(Loading);
Vue.use(Overlay);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(Form);
Vue.use(Field);
Vue.use(Picker);
Vue.use(Area);
Vue.use(Uploader);
Vue.use(Empty);
Vue.use(List);
Vue.use(Progress);
Vue.use(Popover);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Divider);


//Vue.component('k-progress', KProgress);


//Vue.use(vueToTop)

//Vue.use(VueFullPage);

import axios from 'axios'
// axios.defaults.withCredentials=true;
Vue.prototype.axios = axios;
//axios.defaults.baseURL = '/api';

Vue.config.productionTip = false;
Vue.prototype.wx = wx;

//FastClick.attach(document.body);

router.beforeEach((to, from, next) => {
	//document.title = i18n.t('title.title');
	/* if(!localStorage.getItem('token') && to.path !== '/login') {
		//next('/login');
		next();
	}else {
		document.title = to.meta.title;
		next();
	} */
	//PC端无法访问
	let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
	if(flag) {
		Toast.clear();
		document.title = to.meta.title;
		next();
	}else {
		Toast({
			message: '请在手机端访问项目',
			duration: 0,
		});
	}
});

router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
